import { LegGroup, LegRow } from "./use-bet-legs";

const LinkedLegs = ({ legs }: { legs: LegRow[] }) => (
  <ul className="bet_list__linked_legs">
    {legs.map((leg) => (
      <li key={leg.key} className={`bet_list__linked_leg bet_list__linked_leg--${leg.status}`}>
        <span className={`bet_list__status_dot bet_list__status_dot--${leg.status}`} />
        <span className="bet_list__line_type pl-fontSContrast">{leg.label}</span>
      </li>
    ))}
  </ul>
)

export const BetLegGroups = ({ legGroups }: { legGroups: LegGroup[] }) => (
  <ul className="bet_list__lines">
    {legGroups.map((group) => {
      if (group.kind === 'line') {
        return (
          <li key={group.key} className={`bet_list__line bet_list__line--${group.row.status}`}>
            <span className={`bet_list__status_dot bet_list__status_dot--${group.row.status}`} />
            <span className="bet_list__line_type pl-fontSContrast">{group.row.label}</span>
            {group.row.multiplier && <span className="bet_list__multiplier pl-fontXSContrast">{group.row.multiplier}</span>}
          </li>
        )
      }

      return (
        <li key={group.key} className={`bet_list__group bet_list__line--${group.status}`}>
          <div className="bet_list__group_header">
            <span className="bet_list__group_title pl-fontXS">{group.title}</span>
            <span className="bet_list__group_meta">
              {group.kind === 'multiGame' ? (
                <span className="bet_list__match_tracker" title={group.progress}>
                  {group.matches.map((match, index) => (
                    <span key={index} className={`bet_list__match_dot bet_list__match_dot--${match}`} />
                  ))}
                </span>
              ) : group.progress && (
                <span className={`bet_list__group_progress bet_list__group_progress--${group.status} pl-fontXSContrast`}>{group.progress}</span>
              )}
              {group.multiplier && <span className="bet_list__multiplier pl-fontXSContrast">{group.multiplier}</span>}
            </span>
          </div>
          {group.kind === 'multiGame' && <span className="bet_list__group_caption pl-fontXS">Every match</span>}
          <LinkedLegs legs={group.kind === 'parlay' ? group.legs : group.requirements} />
        </li>
      )
    })}
  </ul>
)
